import { useTranslation } from 'react-i18next';
import { CashAccount } from '../../generated/graphql';
import { AmountTableProps, AmountTable } from './Table';

export interface CashAccountsTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  onItemClicked?: (a: { cashAccount: CashAccount }) => void;
  cashAccountArray?: CashAccount[];
  children?: (p: { cashAccount: CashAccount }) => React.ReactNode;
}

export const CashAccountsTableContainer = ({
  children,
  cashAccountArray,
  ...props
}: CashAccountsTableContainerProps) => {
  const { t: tCommon } = useTranslation('common');

  return (
    <AmountTable hideOnEmpty={props.hideOnEmpty ?? true} title={props.title ?? tCommon('cash-accounts')} {...props}>
      {cashAccountArray?.sort((a, b) => a.name.localeCompare(b.name)).map((cashAccount) => children?.({ cashAccount }))}
    </AmountTable>
  );
};
